import {CTABanner} from '@primer/react-brand/esm'
import type {Document} from '@contentful/rich-text-types'
import type {Asset} from '@github-ui/swp-core/schemas/contentful/contentTypes/asset'
import {Logo} from '../FlexSuiteLogos/Logo'
import {renderWithoutParagraphs} from '../../utils'

export type FlexSuiteTestimonialBannerProps = {
  quote?: Document
  link?: {href: string; text: string}
  logo?: string
  image?: Asset
}

export function FlexSuiteTestimonialBanner({quote, link, logo, image}: FlexSuiteTestimonialBannerProps) {
  if (!quote) return null

  return (
    <CTABanner variant={image ? 'balanced' : 'default'} hasGridLines>
      {logo && (
        <CTABanner.Logo>
          <Logo name={logo} />
        </CTABanner.Logo>
      )}
      <CTABanner.Heading size="5">{renderWithoutParagraphs(quote)}</CTABanner.Heading>
      {link && <CTABanner.Link href={link.href}>{link.text}</CTABanner.Link>}
      {image && <CTABanner.Image src={`${image.fields.file.url}?fm=webp&w=720`} alt={image.fields.description ?? ''} />}
    </CTABanner>
  )
}
